var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('v-responsive',{staticClass:"grey lighten-4 mx-auto rounded-xl",attrs:{"aspect-ratio":1/2,"min-width":"calc(min(calc(100vw), calc(512px)) - 2rem)","max-width":"512px"}},[_c('mobile-pass-preview',{attrs:{"preview-url":_vm.extraData.previewUrl}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }